import { useState, useEffect } from 'react';
import { ActionIcon } from '@inexture/core';
import { BiChevronsUp } from 'react-icons/bi';

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-5 right-5 z-[2]">
      <ActionIcon bg="gray.4" variant="light" size="xl" onClick={scrollToTop}>
        <BiChevronsUp size={30} />
      </ActionIcon>
    </div>
  );
};

export default ScrollToTop;
